"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MergeCustomerInput = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.MergeCustomerInput = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        fromCustomerId: typebox_1.Type.String({
            format: 'uuid',
        }),
        toCustomerId: typebox_1.Type.String({
            format: 'uuid',
        }),
    }),
    typebox_1.Type.Union([
        typebox_1.Type.Object({
            deleteFromCustomer: typebox_1.Type.Boolean(),
        }),
        typebox_1.Type.Object({
            ordersToMigrate: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({
                format: 'uuid',
            }))),
            serviceGroupingsToMigrate: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({
                format: 'uuid',
            }))),
            subscriptionsToMigrate: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({
                format: 'uuid',
            }))),
        }),
    ]),
]);
//# sourceMappingURL=merge-customer-input.js.map